var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66666 11.3333H2.99999C2.07952 11.3333 1.33333 10.5871 1.33333 9.66665V2.99998C1.33333 2.0795 2.07952 1.33331 2.99999 1.33331H9.66666C10.5872 1.33331 11.3333 2.0795 11.3333 2.99998V4.66665M6.33333 14.6666H13C13.9205 14.6666 14.6667 13.9205 14.6667 13V6.33331C14.6667 5.41284 13.9205 4.66665 13 4.66665H6.33333C5.41285 4.66665 4.66666 5.41284 4.66666 6.33331V13C4.66666 13.9205 5.41285 14.6666 6.33333 14.6666Z",
    stroke: "#FF6B00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon-copy.93ad99dae3a721d158eec488aca760f5.svg";
export { ForwardRef as ReactComponent };